import ManagePanels from './ManagePanels';

import './ManagePanels.scss';

export default ManagePanels;
